import * as testConst from 'app/constants/tests';
import { useTranslation } from 'next-i18next';
import { Question } from 'types/test';
import dynamic from 'next/dynamic';

const Microphone = dynamic(() => import('app/components/tests/Ielts/IeltSpeak/Microphone'), {
  ssr: false,
});

const steps = ({ process, titles, groupQuestions, indexGroup, indexQuestion,
  record, setRecord, timePending, audioData, setAudioData, setNextQuestion }) => {
  const { t } = useTranslation();
  const partNumber = process.match(/\d+/)[0];

  const genarateQuestion = () => {
    let title = '';
    let question: Question | null = null;
    const audio = audioData.find(item => item.partId == partNumber);

    if (indexGroup != null) {
      const listQuestions = groupQuestions[indexGroup];
      question = listQuestions?.list_question[indexQuestion];
      const number = partNumber == testConst.PART_2 ? '' : indexQuestion + 1;
      title = question ? t('ielt_speak_instructions.question_number', { number }) : '';
    }

    if (process.includes('next_part')) {
      title = t('ielt_speak_instructions.complete_part', { part: partNumber });
    }

    const isShowBgWarning = (timePending == testConst.TIME_PENDING_PART_1 && partNumber != testConst.PART_2)
      || (timePending == testConst.TIME_PENDING_PART_2 && partNumber == testConst.PART_2);

    return (
      <div className="form-group">
        <h4 className="mic-box__instruction-title">
          {title || t('ielt_speak_instructions.describe')}
        </h4>

        {!question && !process.includes('next_part') &&
          <div className="mic-box__instruction-desc">
            <p>{t(`ielt_speak_instructions.part${partNumber}_des1`)}</p>
            <p>{t(`ielt_speak_instructions.part${partNumber}_des2`)}</p>
          </div>
        }

        {!question && process.includes('next_part') &&
          <div className="mic-box__instruction-desc">
            <p>{t(`ielt_speak_instructions.complete_part_des`, { part: partNumber })}</p>
            {audio &&
              <audio key={audio?.url + partNumber} id='audio' controls src={audio?.url || null} />
            }
            <p dangerouslySetInnerHTML={{ __html: t(`ielt_speak_instructions.complete_part_des${process === 'part_3_next_part' ? '3' : '2'}`) }} />
          </div>
        }

        {question &&
          <div className="mic-box__instruction-desc">
            <p className={`font-weight-bold ${isShowBgWarning ? 'bg-warning' : ''}`}>
              {question?.title.replace(/<[^>]*>/g, "")}
            </p>
            <i style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: question?.explain! }} />
          </div>
        }
      </div>
    )
  }

  return (
    <div className="card mt-2 step-speak-card">
      <div className="card-header p-0">
        <h3 className="mb-0 text-center recordings-panel__title position-relative">
          {titles[`part_${partNumber}`]}
          <div className={`${record == 'start' ? '' : 'd-none'} mic-box__indicator`}>
            recording
          </div>
        </h3>
      </div>

      <div className="collapse show" data-parent="#accordion">
        <div className="card-body">
          {genarateQuestion()}
          <div className={`mic-box__instruction-desc ${indexQuestion != null ? '' : 'hidden'}`}>
            <Microphone
              state={record}
              partId={partNumber}
              setState={setRecord}
              audioData={audioData}
              setAudioData={setAudioData}
              setNextQuestion={setNextQuestion}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default steps;
